const PrivacyPolicyies = () => {
  return <p>Privacy Policy , Welcomes You !!!</p>;
};

export default PrivacyPolicyies;
